import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

// COMPONENTS
import MBRatingIcon from '@/components/Icons/MBRatingIcon';

// STYLES
import { Container } from './styles';

const imdbLogo = getS3ImageUrl('/logos/services/imdb-logo.svg');
const rTomatoesLogo = getS3ImageUrl('/logos/services/rotten-tomatoes-logo.svg');

const Scores = ({ className, imdb, rTomatoes, mbRating, type }) => {
  if (!(!!imdb || !!rTomatoes || !!mbRating)) return null;

  const isCardType = type === 'card';

  return (
    <Container className={clsx('scores', className, !!type && `scores--${type}`)}>
      <ul>
        {!!imdb && (
          <li className="item item--imdb">
            <img className="scores__img" src={imdbLogo} alt="IMDB" />
            <Typography className="p3">
              <span className="text-semibold">{imdb}/</span>10
            </Typography>
          </li>
        )}
        {!!rTomatoes && (
          <li className="item item--rTomatoes">
            <img className="scores__img" src={rTomatoesLogo} alt="Rotten Tomatoes" />
            <Typography className="p3">
              <span className="text-semibold">{rTomatoes}%</span> {!isCardType && '(Tomatometer)'}
            </Typography>
          </li>
        )}
        {!!mbRating && (
          <li className="item item--mbRating">
            <MBRatingIcon className="scores__img" />
            <Typography className="p3">
              <span className="text-semibold">{mbRating}/</span>5
            </Typography>
          </li>
        )}
      </ul>
    </Container>
  );
};

Scores.defaultProps = {
  imdb: '',
  rTomatoes: '',
  mbRating: '',
  type: '',
};

Scores.propTypes = {
  className: PropTypes.string,
  imdb: PropTypes.string,
  rTomatoes: PropTypes.string,
  mbRating: PropTypes.string,
  type: PropTypes.string, // card
};

export default React.memo(Scores);
